export default {
    namespaced: true,

    actions: {
        send({ commit }, { email, type, body, name }) {
            return window.axios.post('/feedback', { email, type, body, name })
        }
    }
}